import { render } from "./Langs.vue?vue&type=template&id=6ca4c76b&ts=true"
import script from "./Langs.vue?vue&type=script&lang=ts"
export * from "./Langs.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__